import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import responseHandler from "@/plugins/errorHandling";
import {IContract} from '@/model/Contract/contractInterfaces'

interface LockerContractState {
  contracts: IContract[];
  contract: IContract;
  errors: IErrors;
}

const state: LockerContractState = {
  contracts: [],
  contract: {} as IContract,
  errors: {},
};


const getters: GetterTree<LockerContractState, RootState> = {
  contracts: (state): IContract[] => state.contracts,
  contract: (state): IContract|null => state.contract,
  errors: (state) => state.errors,
};

const actions: ActionTree<LockerContractState, RootState> = {
  fetchContracts: ({commit}, filters): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + filters.lockerId + '/contracts',
      method: 'GET',
      params: {
        ...filters,
      },
    }),
    commit,
    'contractsLoaded'
  ),
  clearContracts: ({commit}): any => commit('clearContracts'),
  fetchContract: ({commit}, {lockerId, contractId}):  any => {
    commit('clearContract');
    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'lockers/' + lockerId + '/contracts/' + contractId,
        method: 'GET',
      }),
      commit,
      'contractLoaded'
    )
  },
  createContract: ({ commit }, data): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + data.locker_id + '/contracts',
      method: 'POST',
      data,
    }),
    commit,
    'contractLoaded'
  ),
  // @todo @anyone just to leave note: save is ambiguous
  updateContract: ({commit}, data): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + data.locker_id + '/contracts/' + data.id,
      method: 'POST',
      data,
    }),
    commit,
    'contractLoaded'
  ),
  renewContract: ({commit}, data): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'lockers/' + data.locker_id + '/contracts/' + data.contract_id +'/renew',
      method: 'POST',
      data,
    }),
    commit,
    'contractRenewed'
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  clearErrors: ({commit}): any => commit('cleanErrors'),
};

const mutations: MutationTree<LockerContractState> = {
  contractsLoaded: (state, payload: IContract[]) => {
    state.contracts = state.contracts.concat(payload);
  },
  clearContracts(state) {
    state.contracts = [];
  },
  contractLoaded: (state, payload: IContract) => {
      state.contract = payload;
  },
  contractRenewed: (state, payload: IContract) => {
    state.contract = payload;
  },
  clearContract: (state) => {
    state.contract = {} as IContract;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanErrors(state) {
    state.errors = {};
  },
};

const namespaced: boolean = true;

export const lockerContractModule: Module<LockerContractState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
